import { AdminProviderAlerts } from './AdminProviderAlerts';
import { FeedbackButton } from '../feedback/Feedback';
import { ProviderCreditPopup } from './ProviderCreditPopup';
import { useEffect, useState } from 'react';
import { AccountGate } from '../admin/Gates';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Menu as MenuIcon } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { useAuth } from '../auth/AuthProvider';
import { api } from '../../lib/api';
import { useTheme } from '../../hooks/useTheme';
import type { Preferences } from '../../types/api';
import { IconButton, Spinner } from '../../components/ui';
import { UpgradePrompt } from '../plans/UpgradePrompt';

export function AppShell() {
  const { user, loading } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();
  const [collapsed, setCollapsed] = useState(() => { try { return localStorage.getItem('lumnos.sidebar') === 'collapsed'; } catch { return false; } });
  const [mobileOpen, setMobileOpen] = useState(false);
  const prefs = useQuery({ queryKey: ['preferences'], queryFn: () => api<{ preferences: Preferences }>('/api/preferences').then((r) => r.preferences), enabled: !!user });
  useTheme(prefs.data?.theme);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); nav('/'); }
      if ((e.metaKey || e.ctrlKey) && e.key === '.') { e.preventDefault(); toggle(); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  });
  useEffect(() => setMobileOpen(false), [loc.pathname]);

  const toggle = () => setCollapsed((c) => { try { localStorage.setItem('lumnos.sidebar', c ? 'open' : 'collapsed'); } catch { /* ignore */ } return !c; });

  if (loading) return <div className="center-fill"><Spinner size={22} /></div>;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  return (
    <div className={`shell ${mobileOpen ? 'shell--mobile-open' : ''}`}>
      <div className="shell__sidebar"><Sidebar collapsed={collapsed && !mobileOpen} onToggle={mobileOpen ? () => setMobileOpen(false) : toggle} onNavigate={() => setMobileOpen(false)} /></div>
      {mobileOpen && <div className="shell__scrim" onClick={() => setMobileOpen(false)} />}
      <UpgradePrompt /><ProviderCreditPopup />
      <main className="shell__main">
        <IconButton label="Open menu" className="shell__menu-btn" onClick={() => setMobileOpen(true)}><MenuIcon size={18} /></IconButton>
        <FeedbackButton /><AdminProviderAlerts /><div className="shell__content"><AccountGate><Outlet /></AccountGate></div>
      </main>
    </div>
  );
}
